var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-tabs',{attrs:{"two-lines":"","inverted":"","align":"center"}},_vm._l((_vm.userMenu),function(menu){return (menu.name !== "calendar")?_c('q-route-tab',{key:menu.name,attrs:{"slot":"title","to":menu.slug,"icon":menu.icon,"label":_vm.$T(menu.name)},slot:"title"}):_vm._e()}))],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15f26c9f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Footer.vue
// module id = Pk8a
// module chunks = 72